import {
	AgeGateActions,
	AgeGateConfirmButton,
	AgeGateDeclineButton,
} from '../AgeGate.styles';
import AgeGateLegalNotice from './AgeGateLegalNotice';

const AgeGatePromptActions = ({ translations, onConfirm, onDecline }) => (
	<>
		<AgeGateActions>
			<AgeGateConfirmButton type="button" onClick={onConfirm}>
				{translations.confirm}
			</AgeGateConfirmButton>
			<AgeGateDeclineButton type="button" onClick={onDecline}>
				{translations.decline}
			</AgeGateDeclineButton>
		</AgeGateActions>
		<AgeGateLegalNotice translations={translations} />
	</>
);

export default AgeGatePromptActions;
